import moment from 'moment';
import { SORTING_DIRECTION } from '~/constants/main';
import { TTranslate } from '~/types/main';
import { getTranslate } from '~/utils/helpers';
import { IPickerOption } from '~/view/components/Controls/Pickers/Picker/types';

export enum OrdersRatingColumns {
  // Mobile = 'MOBILE',
  // OrderId = 'ORDER_ID',
  OrderCreated = 'ORDER_CREATED',
  CommentCreated = 'COMMENT_CREATED',
  // Branch = 'BRANCH',
  RatingAverage = 'RATING_AVERAGE',
  RatingOrder = 'RATING_ORDER',
  RatingPickupDelivery = 'RATING_PICKUP_DELIVERY',
  RatingExperience = 'RATING_EXPERIENCE',
  // Comment = 'COMMENT',
}

export const sortFieldsMap = {
  [OrdersRatingColumns.OrderCreated]: 'created_at',
  [OrdersRatingColumns.CommentCreated]: 'comment_created_at',
  [OrdersRatingColumns.RatingAverage]: 'avg_rating',
  [OrdersRatingColumns.RatingOrder]: 'meal',
  [OrdersRatingColumns.RatingPickupDelivery]: 'service',
  [OrdersRatingColumns.RatingExperience]: 'overall',
};

export interface OrdersRatingFilter {
  search: string;
  branches: IPickerOption[];
  dateFrom: string | null;
  dateTo: string | null;
}

export interface OrdersRatingSorting {
  sortField?: OrdersRatingColumns;
  sortDir?: SORTING_DIRECTION;
}

export type OrderRatingResponse = {
  id: number;
  order_id: number;
  avg_rating: number;
  meal: number;
  service: number;
  overall: number;
  comment: string;
  customer: {
    id: number;
    mobile: string;
    name: string;
    is_delete: number;
  };
  order: {
    id: number;
    order_key: number;
    created_at: string;
  };
  branch: {
    id: number;
    name: TTranslate;
  };
  comment_created_at: string;
};

export type OrdersRatingResponse = {
  total: number;
  per_page: number;
  current_page: number;
  last_page: number;
  from: number;
  to: number;
  data: OrderRatingResponse[];
};

export const orderRatingCast = ({
  avg_rating,
  meal,
  service,
  overall,
  comment,
  order,
  customer,
  branch,
  id,
  comment_created_at,
}: OrderRatingResponse) => ({
  id: String(id),
  average: String(avg_rating),
  meal: String(meal),
  service: String(service),
  overall: String(overall),
  comment: comment ? String(comment) : '',
  createdAt: order.created_at,
  commentCreatedAt: comment_created_at,
  orderId: String(order.id),
  orderKey: String(order.order_key),
  userId: String(customer.id),
  userPhone: String(customer.mobile ?? '').replace('+', ''),
  userIsDeleted: Boolean(customer.is_delete),
  userName: customer.name,
  branchName: getTranslate(branch.name),
});

export type OrdersRatingItem = ReturnType<typeof orderRatingCast>;

export const ordersRatingCast = (data: OrderRatingResponse[]) => data.map(orderRatingCast);

export const defaultFilter = {
  search: '',
  branches: [],
  dateFrom: moment().subtract(3, 'months').format('YYYY-MM-DD'),
  dateTo: moment().format('YYYY-MM-DD'),
};

export const defaultPagination = {
  currentPage: 0,
  lastPage: 0,
  perPage: 0,
  totalRows: 0,
};
